import { render, staticRenderFns } from "./DashboardDeliveryCardDetails.vue?vue&type=template&id=c3112712&"
import script from "./DashboardDeliveryCardDetails.vue?vue&type=script&lang=js&"
export * from "./DashboardDeliveryCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports